import gql from 'graphql-tag';
const ACTIVATE_HASHED_EMAIL_LIST = gql`
  mutation activateHashedEmailList(
    $orgID: ID!
    $hashedEmailListIds: [ID]!
    $dsp: String!
  ) {
    activateHashedEmailList(
      data: { orgID: $orgID, hashedEmailListIds: $hashedEmailListIds, dsp: $dsp }
    )
  }
`;

export default ACTIVATE_HASHED_EMAIL_LIST;
